/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/DesignSystem/PreviewDocument/Content/Content/HtmlFile/Content/Content/Content/Actions/Signature/Content/Content/Info"
  
}) {
let constantData = 'This signature request was generated on '
let signatureCreatedAtValueData = fromData.useDataFormat({ viewPath,
context: 'signature',
path: 'created_at',
format: fromFormat.dateISOToDateAndTimeShort,
})
let constantData1 = ' for '
let signatureSignatoryPersonValueData = fromData.useDataFormat({ viewPath,
context: 'signature',
path: 'signatory_person',
format: fromFormat.personName,
})
let constantData2 = '.'
let aggregateData = fromAggregate.joinNoSpace(constantData, signatureCreatedAtValueData, constantData1, signatureSignatoryPersonValueData, constantData2)
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceXxs}
 data="'This signature request was generated on '"
 data="signature.created_at"
 format="/Data/format.js dateISOToDateAndTimeShort"
 data="' for '"
 data="signature.signatory_person"
 format="/Data/format.js personName"
 data="'.'"
 aggregate="/Simple/Data/aggregate.js joinNoSpace"
 text={aggregateData}
/>
{children}
</React.Fragment>)
}